import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';

import { FreeDropAnnouncementModal } from './ancouncement-modal';
import { FreeDropStartAnimation } from './start-animation';
import { AspectRatioImage } from '../cashback/ratio-image';
import { FreeDropPromoTool } from './free-drop-promo-tool';
import { FreeDropsDetailsModal } from './details-modal';
import { FreeDropProgressBar } from './progress-bar';
import { convertAmount } from '../../../../helpers';
import { useStore } from '../../../../hooks';
import { FreeDropZone } from './drop-zone';

import './style.scss';

interface FreeDropProps {
  id: number;
}

export const FreeDrop: React.FC<FreeDropProps> = observer(({ id }) => {

  const { freeDropStore, gameStore } = useStore();

  const { currencyCode, rate, gameReady, isSlotLine } = gameStore;
  const { showAnouncementPopup, showDetailsPopup, dropPrizes, sortedDropsByDate, dropUpdateTrigger, freeDropInfo, themeConfig } = freeDropStore;

  useEffect(() => {
    freeDropStore.getPlayerProgress(id);
    freeDropStore.listenVisibilityChange();
  }, []);

  const nextDrop = useMemo(() => {
    const result = sortedDropsByDate?.find((drop) => {
      return new Date(drop.dropDate).getTime() > Date.now();
    });
    return result || null;
  }, [sortedDropsByDate, dropUpdateTrigger]); // please do not remove dropUpdateTrigger dep

  const nextDropDate = useMemo(() => {
    const dateString = nextDrop?.dropDate;
    if (!dateString) return null;
    return new Date(dateString);
  }, [nextDrop]);

  const minGoal = useMemo(() => {
    const tiersOrderedByGoal = [...nextDrop?.tiers || []].sort((a, b) => a.goal > b.goal ? 1 : -1);
    const userCurrencyFreeBet = tiersOrderedByGoal?.[0]?.freeBets.find((freebet) => freebet.currency === currencyCode);
    if (userCurrencyFreeBet) {
      return userCurrencyFreeBet.goal;
    }
    const campaignCurrencyFreeBet = tiersOrderedByGoal?.[0]?.freeBets.find((freebet) => freebet.currency === freeDropInfo?.currency);
    return convertAmount(campaignCurrencyFreeBet?.goalCoinAmount || 0, rate, 0);
  }, [nextDrop, currencyCode, freeDropInfo, rate]);

  if (!gameReady) return null;

  return (
    <div className={`free-drop-wrapper ${themeConfig.className}`}>
      <AspectRatioImage />
      <FreeDropStartAnimation />
      {
        showAnouncementPopup && (
          <FreeDropAnnouncementModal nextDropDate={nextDropDate} />
        )
      }
      {
        dropPrizes.length ? (
          <FreeDropZone
            minGoal={minGoal}
            prizes={dropPrizes}
            nextDrop={nextDrop}
          />
        ) : null
      }
      {
        showDetailsPopup && (
          <FreeDropsDetailsModal
            minGoal={minGoal}
            nextDropDate={nextDropDate}
          />
        )
      }
      {
        isSlotLine ? (
          <FreeDropPromoTool nextDrop={nextDrop} nextDropDate={nextDropDate} />
        ) : (
          <FreeDropProgressBar nextDrop={nextDrop} nextDropDate={nextDropDate} />
        )
      }
    </div>
  );
});
